import React from "react";
import Blink from "./Blink.js"

export default function Title(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.title) {
    return null;
  }
  
  return (
    <div
      // id={"Title"}
      style={{
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "100",
        flexDirection: "column",
        opacity: currentSlide.title ? "1" : "0.0",
        //backgroundColor: "#7498b0", // "black", 7dffb3  00ff7f
        pointerEvents: "none",
        // zIndex: 20,
        width: "100vw",
        height: "100vh",
        WebkitTransition: "opacity 2s",
      }}
      // className={`scrollable-video__container`}
    >
      {currentSlide.title.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color: "white",
            fontWeight: i===0 ?"650": "normal",
            fontSize: props.isMobile? (i===0? "7.5vw": (i===1) ? "5vw":"3vw"):(i===0? "2.2vw": (i===1) ? "1.3vw":"1.3vw"),
            fontStyle: i===1 ?"italic": "normal",
            textAlign: "center",
            margin: props.isMobile? "1vw 5vw":"1vw 20vw",
            padding: props.isMobile? "1vw":"0vw",
          }}
        >
          {p}
      </div> 
      ))}
          <Blink>
          <div
              style={{
                borderLeft: "1px white solid",
                height: props.isMobile? "10vw":"5vw",
                display: "inline-block",
              }}
            />
          </Blink>
          <Blink>
          <div
              style={{
                color: "white",
                fontSize: props.isMobile? "3vw":"1.3vw",
              }}
            >Scroll
        </div>
        </Blink>
        </div>
  );
}

